import { EtiquetasGenerales_EN } from "./Genericos/EtiquetasGenerales_EN";

const EtiquetasModulo = {
  NombrePortal: {
    Et_Nombre: "New Admission Portal",
  },
  Home: {
    Et_lblHola: "Hello",
    Et_lblSaludosDia: "Welcome to the new admission portal",
    Et_lblDescripcion:
      "Don't let your goals stop, start your academic project and make your dreams come true.",
    Et_lblRegistro: "Registration",
    Et_lblAdmision: "Admission",
    Et_lblDatosPersonales: "Personal Information",
    Et_lblContactos: "Contacts",
    Et_lblSeleccion: "Selection",
    Et_lblRequisitosAdmision: "Admission Requirements",
    Et_lblCodigoVerificacion: "Verification Code",
    Et_lblCodigoVerificacionDescripcion:
      "Please enter your corresponding verification code.",
    Et_lblAdmisionProgramas: "Career",
    Et_lblAdmisionPlanes: "Program",
    Et_lblDocumento: "Document",
    Et_lblAdjuntar: "Attach",
    Et_lblObtenerCodigo: "Resend verification code",
    Et_lblAdjuntosPendientes:
      "There are pending admission requirements to attach to the requested documentation.",
    Et_lblEnviarAdmisionMsg:
      "We have received your admission application. The institution's staff will validate the documentation and you will receive an email with the next steps. Thank you for choosing our institution!",
    Et_lblOrigen: "Origin",
    Et_InformacionAdicional: "Additional Information",
    Et_lblcomenzar: "Start",
  },
  InterfazDatosPersonales: {
    Et_TituloPrincipal: "Personal Information",
    Et_tblCusTipoCIF: "CIF Type",
    Et_tblCusTypeIdeFk: "Identification Type",
    Et_tblCusTypeIdeFkShort: "ID Type",
    Et_tblcusFullName: "Full Name",
    Et_tblCusLastName1: "First Surname",
    Et_tblCusLastName2: "Second Surname",
    Et_tblFechaNacimiento: "Date of Birth",
    Et_tblCusCivilStatusFkShort: "Civil Status",
    Et_tblCusCivilStatusFk: "Civil Status",
    Et_tblCusGenderFk: "Gender",
    Et_tblValidIdeMinimo:
      "The ID number has fewer digits ({0}) than allowed for the selected identification type ({1}).",
    Et_tblValidIdeMaximo:
      "The ID number has more digits ({0}) than allowed for the selected identification type ({1}).",
    Et_tblValidIdeFormato:
      "The ID number is not in the required format for the selected identification type. {0}",
    Et_tblIdeFormato: "Valid format: {0}.",
    Et_tblInvalidIde: "Invalid identification number.",
    Et_tblCusApellidoCasada: "Married Surname",
    Et_tblCusCorrelativoDPI: "DPI Correlative",
    Et_tblCusDeptoNacimiento: "Birth Department",
    Et_tblFechaVencimiento: "Expiration Date",
    Et_tblCusMuniNacimiento: "Birth Municipality",
    Et_tblCusOcupacion: "Occupation",
    Et_tblCusOrdenCedula: "Order of ID",
    Et_tblCusPaisNacimiento: "Country of Birth",
    Et_tblCusRegistroCedula: "ID Registration",
    Et_tblCusVecindad: "Neighborhood",
  },
  InterfazClienteContactInfo: {
    Et_tblAddress: "Addresses",
    Et_tblAddressType: "Address Type",
    Et_tblCountry: "Country",
    Et_tblProvince: "Province",
    Et_tblCanton: "Canton",
    Et_tblDistrict: "District",
    Et_tblNeighborhood: "Neighborhood",
    Et_tblExactAdress: "Exact Address",
    Et_tblPostalCode: "Postal Code",
    Et_tblContact: "Phones",
    Et_tblPhoneType: "Phone Type",
    Et_tblPhone: "Phone",
    Et_tblCountryCode: "Country Code",
    Et_SelecAddTy: "Select the address type",
    Et_SelecContactTyp: "Select the contact type",
    Et_SelecEmailTyp: "Select the email type",
    Et_tblEmailTittle: "Email",
    Et_tblEmailType: "Email Type",
    Et_tblEmail: "Email",
  },
  PlantillaCorreoToken: {
    Et_Hola: "Hello ",
    Et_TextoSuCodigo: "Your verification code is: ",
    Et_Gracias: "Thank you for using our portal.",
    Et_Asunto: "Verification Code",
  },
  InterfazNacionalidad: {
    Et_tblCountrys: "Nationalities",
    Et_tblCIFs: "CIF Types",
    Et_SelecCIFs: "CIF Type",
    Et_tblCIF: "CIF Type",
    Et_SelecCountry: "Country",
    Et_SelecTypeCountry: "Nationality Type",
    Et_tblCountry: "Country",
    Et_tblTypeCountry: "Nationality Type",
    Et_tblNacionalidad: "National",
    Et_tblRecidencia: "Residence",
  },
  PagoEnLinea: {
    Et_TituloPrincipal: "Online Payment",
    Et_Descripcion: "Pay the invoice with a credit or debit card",
    Et_Redireccion: "You will be redirected to our secure payment gateway.",
    Et_TituloModalPago: "Complete your payment",
    Et_DescripcionModalPago:
      "To continue with your enrollment you need to pay the admission PIN.",
    Et_TotalAPagar: "Total to pay",
    Et_AvisoRedireccion:
      "You will be redirected to our secure payment gateway to complete the transaction.",
    Et_Cancelar: "Cancel",
    Et_IrAPagar: "Go to pay",
    Et_AvisoPagoCajas:
      "Online payment is not available. Please visit the cashier to pay the enrollment PIN.",
    Et_Aceptar: "Accept",
    Et_TituloPagoPendiente: "Payment in process",
    Et_DescripcionPagoPendiente:
      "You already have a payment in process. Please close any other payment processes open in your browser before continuing.",
    Et_TituloPagoExitoso: "Your payment was successful!",
    Et_DescripcionPagoExitoso:
      "Your payment was received successfully. The institution will review your requirements and notify you of the next steps by email.",
    Et_AvisoComprobante:
      "Check your inbox to find the payment receipt.",
    Et_TituloPagoFallido: "There was a problem with your payment",
    Et_DescripcionPagoFallido:
      "We could not confirm your payment. No charge was made or the process was incomplete. You can try again from the student portal.",
    Et_Salir: "Exit",
    Et_ContinuarAlInicio: "Continue to home",
  },
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_EN, ...EtiquetasModulo };

const Etiquetas_En = {
  Idioma: "EN",
  Etiquetas: EtiquetasUnificadas,
};

export default Etiquetas_En;
